import React from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import Separator from "../../../../../../global components/Icons/Separator";
import BreadCrumb from "../../../../../../global components/BreadCrumbs/BreadCrumbs";
import s from "./InnerPage.module.scss";
import Envelope from "../../../../../../global components/Icons/Envelope/Envelope";
import clsx from "clsx";

function InnerPage() {
  const location = useLocation();
  const pathName = location.pathname;

  const items = [
    {
      title: <Link to="/dashboard/promo-code">Promo codes</Link>,
      icon: <Envelope width={16} height={11} fill="#BEC2CA" />,
    },
  ];

  // Conditionally add "Edit" or "Create" based on pathName
  if (pathName.includes("edit")) {
    items.push({
      title: (
        <Link
        onClick={(e)=>e.preventDefault()}

          className={clsx(pathName.includes("edit") && s.active)}
          to="/dashboard/promo-code/create/edit"
        >
          Edit
        </Link>
      ),
      icon: <></>,
    });
  } else if (pathName.includes("create")) {
    items.push({
      title: (
        <Link
        onClick={(e)=>e.preventDefault()}

          className={clsx(pathName.includes("create") && s.active)}
          to="/dashboard/promo-code/create"
        >
          Create
        </Link>
      ),
      icon: <></>,
    });
  }

  return (
    <div className={s.wrapper}>
      <div className={s.BreadCrumb}>
        <BreadCrumb
          items={items}
          separator={<Separator height={11} width={6.67} fill="#9CA3AF" />}
        />
      </div>
      <Outlet />
    </div>
  );
}

export default InnerPage;
